import script from "./KendouPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouPage.vue?vue&type=script&setup=true&lang=js"

import "./KendouPage.vue?vue&type=style&index=0&id=590a49a0&lang=scss"

const __exports__ = script;

export default __exports__